// extracted by mini-css-extract-plugin
export default {"wrapper":"uC-z","button":"vC-z","alternate":"wC-z","disabled":"xC-z","paymentWarning":"yC-z","fadeIn":"zC-z"};